import { FC, PropsWithChildren, ReactNode } from 'react'

import { useUserPermission, UseUserPermissionProps } from '@/hooks/useUserPermission'

interface UseUserPermissionWrapperProps extends UseUserPermissionProps {
  fallbackMessage?: ReactNode
}

export const UserPermissionWrapper: FC<PropsWithChildren<UseUserPermissionWrapperProps>> = ({
  children,
  fallbackMessage,
  privilegeName,
  quantifier,
}) => {
  const hasPermission = useUserPermission({ privilegeName, quantifier })

  if (hasPermission) {
    return children
  }

  return fallbackMessage
}
